import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  typographyLoadingText: {
    color: theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '20px',
    marginBottom: '8px',
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <Grid container justify="center">
      <Typography className={classes.typographyLoadingText}>Loading 100% successfully</Typography>
    </Grid>
  );
};
